import { QueryClient } from 'react-query';
import { i18n } from '../src/i18n';

let selectedLocale;
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 3000,
    },
  },
});

export const getLanguage = () => {
  const currentSelectedLanguage = selectedLocale || i18n.language;
  return currentSelectedLanguage;
};

export const setLanguage = language => {
  selectedLocale = language;
  return true;
};
